import React from 'react';
import './Pricing.css';

import { Heading, Plan } from '../../../components';
import { pricing } from '../../../constants';



const Pricing = () => {

  return (
    <section className='pricing'>

      {/* Section Heading */}
      <Heading title={'Car Rental Packages'} subTitle={'Explore Our Plans'} />

      {/* Pricing container */}
      <div className='box-container'> 
        {/* Loop through each plan and render the Plan component */}
        {pricing.map((plan) => (
          <Plan key={plan.id} plan={plan} />
        ))
        }
      </div>

    </section>
  )
}

export default Pricing;